





















































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, Document } from '../../types/request';
import { LoaderEvent, ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { ApiResponse } from '@/types/response';
import { required } from 'vuelidate/lib/validators';
// tslint:disable-next-line: no-var-requires
const LienCustomerDocuments = require('../../config/LienCustomerDocuments');

@Component({
    mixins: [validationMixin],
    props: {
        request: Object,
    },
    computed: {
        disableUploadButton() {
            if (!this.$data.documentName) {
                return true;
            }
            if (this.$data.documentName !== 'ALOP') {
                return false;
            }
            return !this.$data.attorneyName ||
             (this.$data.attorneyName.toLowerCase() !== this.$data.requestAttorneyName.toLowerCase());
        },
    },
    data() {
        return {
            documentName: '',
            attorneyName: '',
            requestAttorneyName: '',
        };
    },
    validations: {
        attorneyName: {
            required,
        },
    },
})
export default class UploadLienCustomerDocumentsModal extends Vue {
    private show = true;
    private showDeleteConfirmBox = false;
    private selectedDocument: Document | null = null;
    private documents: Document[] = JSON.parse(JSON.stringify(LienCustomerDocuments.documents));
    private disableUpload = true;
    private uploadedDocuments: Document[] = [];
    get isFileToUpload() {
        return this.documents.findIndex((document: Document) => {
            return document.file && !document.resourceId;
        }) >= 0;
    }

    public mounted() {
        const request = this.$props.request;
        this.$data.requestAttorneyName = request.transportRequest.lienRequest.attorneyName;
        if (request.transportRequest && request.transportRequest.lienRequest) {
            if (request.transportRequest.lienRequest.documents) {
                request.transportRequest.lienRequest.documents.forEach((element: Document) => {
                    const index = this.documents.findIndex((document) => {
                        return document.name === element.name;
                    });
                    if (index >= 0) {
                        this.documents[index] = JSON.parse(JSON.stringify(element));
                    }
                });
            }
        }
    }
    private async setDocument($event: any, document: Document, index: number) {
        const filename: string = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
            filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            this.documents[index].file = $event.target.files[0];
            this.documents[index].filename = $event.target.files[0].name;
            this.documents[index].resourceId = '';
            this.$data.documentName = document.name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = `file-input${index}`;
            const element = this.$refs[inputName] as any;
            element[0].reset();
        }
        this.disableUpload = !this.isFileToUpload;
    }
    private async removeDocument() {
        if (this.selectedDocument) {
            if (this.selectedDocument.resourceId) {
                const response = await ObjectFactory.getFileService().
                    deleteFile(this.selectedDocument.resourceId, this.$store.state.serverUrl);
                if (response.success) {
                    this.selectedDocument.resourceId = '';
                }
            }
            this.selectedDocument.file = undefined;
            this.selectedDocument.filename = '';
            this.showDeleteConfirmBox = false;
        }
        this.disableUpload = !this.isFileToUpload;
    }
    private async saveDocuments() {
        const promises: Array<Promise<ApiResponse<string>>> = [];
        const indexes: number[] = [];
        let index = 0;
        const iHttpService = ObjectFactory.getHttpService();
        this.documents.forEach((document: Document) => {
            if (document.file) {
                const patientId = this.$props.request.appointment.patient.id;
                const requestId = this.$props.request.id;
                const formData = new FormData();
                formData.append('file', document.file as any);
                formData.append('documentName', document.name);
                if (document.description) {
                    formData.append('description', document.description);
                }
                formData.append('attorneyName', this.$data.attorneyName);
                formData.append('requestId', requestId);
                indexes.push(index);
                const apiRequest: ApiRequest = {
                    baseURL: this.$store.state.serverUrl,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/${patientId}/upload`,
                    data: formData,
                    loaderEvent: {
                        show: true,
                    },
                };
                promises.push(iHttpService.put<string>(apiRequest));
            }
            index++;
        });
        if (promises.length >= 1) {
            const loaderEvent: LoaderEvent = {
                show: true,
                message: 'Uploading',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
            Promise.all(promises).then((uploadDocumentResponses) => {
                const toastEvent: ToastEvent = {
                    message: 'Document Uploaded!',
                    title: 'Success!',
                    timeout: 2000,
                    varient: 'success',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }).catch(() => {
                const toastEvent: ToastEvent = {
                    message: 'Failed to upload document',
                    title: 'Error!',
                    timeout: 5000,
                    varient: 'danger',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }).finally(() => {
                loaderEvent.show = false;
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
                this.close();
            });
        }
    }
    private close() {
        this.$emit('close');
    }
}
